<template>
  <div class="smy__card-full-box">
    <Card :bordered="false" class="smy__card-full">
      <p slot="title">订单审批</p>
      <div class="search">
        <!-- 详细筛选条件 -->
        <div>
          <div
            class="search-detail"
            :class="{ 'search-detail-close': !searchVisible }"
            :style="{ overflow: !searchVisible ? 'hidden' : '' }"
          >
            <div class="search-detail-item">
              <Input
                class="search-input"
                placeholder="请输入订单号"
                v-model="searchForm.order_no"
              ></Input>
            </div>
            <div class="search-detail-item">
              <Input
                class="search-input"
                placeholder="请输入企业名称"
                v-model="searchForm.ep_name"
              ></Input>
            </div>
            <div class="search-detail-item">
              <Input
                class="search-input"
                placeholder="请输入corpID"
                v-model="searchForm.corpid"
              ></Input>
            </div>
            <div class="search-detail-item">
              <Select
                clearable
                filterable
                class="search-input"
                placeholder="请选择订单类型"
                element-id="ordertype"
                v-model="searchForm.type"
              >
                <Option
                  v-for="spareType in orderList"
                  :key="spareType.id"
                  :value="spareType.id"
                >
                  {{ spareType.name }}
                </Option>
              </Select>
            </div>
            <div class="search-detail-item">
              <Select
                clearable
                filterable
                class="search-input"
                placeholder="请选择订单状态"
                element-id="orderstate"
                v-model="searchForm.order_state"
              >
                <Option
                  v-for="spareType in roderstateList"
                  :key="spareType.id"
                  :value="spareType.id"
                >
                  {{ spareType.name }}
                </Option>
              </Select>
            </div>
            <div class="search-detail-item">
              <DateRangePicker
                class="search-input"
                :placeholder="'请选择下单时间'"
                :value="emptyORderTime"
                @on-change="
                  daterangeChange($event, 'order_start_time', 'order_end_time')
                "
              />
            </div>
            <div class="search-detail-item">
              <DateRangePicker
                class="search-input"
                :placeholder="'请选择开通时间'"
                :value="emptyOpenTime"
                @on-change="
                  daterangeChange(
                    $event,
                    'inception_start_time',
                    'inception_end_time'
                  )
                "
              />
            </div>
            <div class="search-detail-item">
              <FilterColumn
                :column="allColumns"
                @columnsChecked="columnsChecked = $event"
              />
              <Button
                type="primary"
                class="search-button"
                @click=";(pageIndex = 0), loadList()"
              >
                查找
              </Button>
              <Button class="search-button" @click="resetSearchForm">
                重置
              </Button>
            </div>
          </div>
        </div>
      </div>
      <!-- 工单列表 -->
      <div class="table table-sticky">
        <Table
          stripe
          ref="table"
          :loading="listLoading"
          :columns="columns"
          :data="list"
        ></Table>
      </div>
      <!-- 分页控件 -->
      <Page
        show-total
        show-sizer
        class="page"
        placement="top"
        :current="pageIndex + 1"
        :total="count"
        :page-size-opts="pageSizeOpts"
        @on-change="pageIndexChange"
        @on-page-size-change="pageSizeChange"
      ></Page>
      <!-- 驳回原因 -->
      <Modal
        :mask-closable="false"
        :loading="loading"
        v-model="visible"
        @on-ok="ResonBack('resetLostForm')"
        title="审批驳回"
      >
        <Form label-position="right" :model="resetLostForm" :label-width="80">
          <FormItem label-for="reason" label="驳回原因">
            <Input v-model="resetLostForm.reason" placeholder=""></Input>
          </FormItem>
        </Form>
      </Modal>
    </Card>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

import DateRangePicker from '@/components/DateRangePicker'

export default {
  components: {
    DateRangePicker,
  },
  data() {
    return {
      columnsChecked: [],
      orderID: '',
      loading: true,
      visible: false,
      resetLostForm: {
        reason: '',
      },
      emptyORderTime: ['', ''],
      emptyOpenTime: ['', ''],
      palyName: '',
      busType: '',
      buyPeople: '',
      corpid: '',
      BUYButton: 0,
      editModal: false, // 购买弹窗
      planId: 1,
      editTitle: '购买',
      type: 1,
      editReportCurstom: false, // 报备客户
      searchVisible: true, // 是否显示详细筛选条件
      pageSize: 10,
      pageIndex: 0,
      listLoading: false, // 表格加载状态
      count: 0,
      list: [],
      searchForm: {
        ep_name: '',
        corpid: '',
        type: '',
        packId: '',
        use_year_type: '',
        is_special: '',
        order_start_time: '',
        order_end_time: '',
        inception_start_time: '',
        inception_end_time: '',
        order_no: '',
      },
      orderList: [
        {
          id: '-1',
          name: '全选',
        },
        {
          id: '1',
          name: '购买',
        },
        {
          id: '2',
          name: '升级',
        },
        {
          id: '3',
          name: '续费',
        },
      ],
      roderstateList: [
        {
          id: '-1',
          name: '全选',
        },
        {
          id: '1',
          name: '订单审批中',
        },
        {
          id: '2',
          name: '订单处理中',
        },
        {
          id: '3',
          name: '订单已完成',
        },
        {
          id: '0',
          name: '订单已驳回',
        },
      ],
    }
  },
  computed: {
    ...mapState('table', ['columnsCheckedAll', 'pageSizeOpts']),
    // 表格列 根据选中的列动态生成
    allColumns() {
      const allColumns = [
        {
          title: '操作',
          width: 240,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            let check = h(
              'Button',
              {
                props: {
                  type: 'ghost',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this._isShowApproveBtn(true)
                    this.$router.push({
                      name: 'AgOrderApproveOrderDetail',
                      params: { orderId: row.id },
                    })
                  },
                },
              },
              ['查看']
            )
            let passEdit = h(
              'Button',
              {
                props: {
                  type: 'ghost',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.listLoading = true
                    let url = '/order/platformMgrAuditPass'
                    let data = {
                      orderId: row.id,
                    }
                    this.$http.put(url, data).then((res) => {
                      if (res.success) {
                        let msg = '审核成功'
                        this.$Message.success(msg)
                        this.listLoading = false
                        this.loadList()
                      } else {
                        this.$Message.error(res.message)
                      }
                    })
                  },
                },
                style: {
                  marginLeft: '10px',
                },
              },
              ['审批通过']
            )
            let failEdit = h(
              'Button',
              {
                props: {
                  type: 'ghost',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.visible = true
                    this.orderID = row.id
                  },
                },
                style: {
                  marginLeft: '10px',
                },
              },
              ['审批驳回']
            )
            return h('span', [check, passEdit, failEdit])
          },
        },
        {
          title: '订单号',
          key: 'order_no',
          width: 180,
          ellipsis: true,
        },
        {
          title: '企业名称',
          key: 'ep_name',
          width: 140,
        },
        {
          title: 'CorpID',
          key: 'corpid',
          width: 180,
          ellipsis: true,
        },
        {
          title: '代理商业务员',
          key: 'business_user_name',
          width: 180,
          ellipsis: true,
        },
        {
          title: '订单类型',
          key: 'type',
          width: 100,
          render: (h, { row }) => {
            let Type = ''
            if (row.type === 1) {
              Type = '购买'
            } else if (row.type === 2) {
              Type = '升级'
            } else {
              Type = '续费'
            }
            return h('span', [Type])
          },
        },
        {
          title: '订单内容',
          key: 'use_year_type',
          width: 140,
          render: (h, { row }) => {
            let Year = row.use_year_type
            for (var item of this.buyPeople) {
              if (item.value === row.fk_t_charge_package_id) {
                if (row.type === 2) {
                  if (row.fk_t_charge_package_id === 8) {
                    return h('span', ['不限工号'])
                  } else {
                    return h('span', [item.maxNum + '用户'])
                  }
                } else {
                  if (row.fk_t_charge_package_id === 8) {
                    return h('span', ['不限工号' + Year + '年'])
                  } else {
                    return h('span', [item.maxNum + '用户' + Year + '年'])
                  }
                }
              }
            }
          },
        },
        {
          title: '是否为特殊订单',
          key: 'is_special',
          width: 140,
          render: (h, { row }) => {
            let specialOrder = ''
            if (row.is_special === 1) {
              specialOrder = '是'
            } else {
              specialOrder = '-'
            }
            return h('span', [specialOrder])
          },
        },
        {
          title: '订单状态',
          key: 'order_state',
          width: 140,
          render: (h, { row }) => {
            let specialOrder = ''
            if (row.order_state === 0) {
              specialOrder = '订单已驳回'
            } else if (
              row.order_state === 1 ||
              row.order_state === 2 ||
              row.order_state === 3
            ) {
              specialOrder = '订单审批中'
            } else if (row.order_state === 4) {
              specialOrder = '订单处理中'
            } else {
              specialOrder = '订单已完成'
            }
            return h('span', [specialOrder])
          },
        },
        {
          title: '下单时间',
          key: 'create_time',
          width: 180,
        },
        {
          title: '代理付款金额',
          key: 'customer_price',
          width: 140,
        },
        {
          title: ' ',
          key: ' ',
        },
      ]
      return allColumns
    },
    columns() {
      const allColumns = this.allColumns
      let arr = allColumns.filter((col) => {
        if (!col.key || !col.key.trim()) {
          return true
        } else {
          if (this.columnsChecked.length) {
            return this.columnsChecked.includes(col.key)
          } else {
            return true
          }
        }
      })
      if (this.columnsChecked.length) {
        let indexMap = this.columnsChecked.reduce((p, c, i) => {
          p[c] = i
          return p
        }, {})
        let left = arr.filter((col) => this.columnsChecked.includes(col.key))
        let right = arr.filter((col) => !this.columnsChecked.includes(col.key))
        arr = left
          .sort((p, c) => indexMap[p.key] - indexMap[c.key])
          .concat(right)
      }
      return arr
    },
  },
  methods: {
    ...mapMutations('table', ['_isShowApproveBtn']),
    ResonBack(val) {
      this.resetlLoading = false
      setTimeout(() => {
        this.resetlLoading = true
      }, 50)
      let data = {
        orderId: this.orderID,
        reason: this.resetLostForm.reason,
      }
      let url = '/order/platformMgrAuditUnPass'
      this.$http.put(url, data).then((res) => {
        if (res.success) {
          let msg = '审核成功'
          this.loadList()
          this.$Message.success(msg)
          this.visible = false
          this.editListModal = false
          this.resetLostForm.reason = ''
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    // 加载列表数据
    loadList() {
      this.listLoading = true
      this.$http
        .all([
          this.$http.get('/order/waitaudit/platformMgr/list', {
            params: {
              pageIndex: this.pageIndex,
              pageSize: this.pageSize,
              ...this.searchForm,
            },
          }),

          this.$http.get('/order/waitaudit/platformMgr/count', {
            params: this.searchForm,
          }),
        ])
        .then(
          this.$http.spread((res1, res2) => {
            this.list = res1.data
            this.count = res2.data
            this.listLoading = false
          })
        )
    },
    // 分页 每页大小 改变回调
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange(pageIndex) {
      this.pageIndex = pageIndex - 1
      this.loadList()
    },
    // 日期 改变回调
    daterangeChange(daterange, start, end) {
      if (daterange[0]) {
        this.searchForm[start] = daterange[0]
          .replace('/', '-')
          .replace('/', '-')
        this.searchForm[end] = daterange[1].replace('/', '-').replace('/', '-')
      } else {
        this.searchForm[start] = ''
        this.searchForm[end] = ''
      }
      this.emptyORderTime = [this.searchForm[start], this.searchForm[end]]
      this.emptyOpenTime = [this.searchForm[start], this.searchForm[end]]
    },
    // 重置搜索框
    resetSearchForm() {
      this.emptyORderTime = ['', '']
      this.emptyOpenTime = ['', '']
      this.searchForm = {
        order_no: '',
        ep_name: '',
        corpid: '',
        order_start_time: '',
        order_end_time: '',
        inception_start_time: '',
        inception_end_time: '',
        type: '',
        order_state: '',
      }
      this.loadList()
    },
    editReport() {
      this.editReportCurstom = true
    },
  },
  created() {
    this.$http.get('/dropdown/industry').then((res) => {
      this.busType = res.data
    })
    this.$http.get('/dropdown/chargePackage').then((res) => {
      this.buyPeople = res.data
    })
    this.loadList()
  },
}
</script>

<style lang="less" scoped>
.search {
  margin-bottom: 16px;
  .search-top {
    display: flex;
    justify-content: space-between;

    .search-top-left {
      display: flex;
      width: 70%;

      .search-input {
        width: 80%;

        // margin-left: 10px;
      }

      .search-button {
        margin-left: 10px;
      }
    }

    .search-top-right {
      .filter-column {
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .search-button {
        margin-left: 6px;
      }
    }
  }

  .search-detail {
    display: flex;
    flex-wrap: wrap;
    height: 80px;
    transition: 0.5s;

    .search-detail-item {
      width: 24.25%;

      .search-input {
        width: 100%;
        margin-bottom: 10px;
      }

      .search-button {
        margin-right: 6px;
      }
    }

    .search-detail-item:nth-child(2n + 1),
    .search-detail-item:nth-child(4n + 2) {
      margin-right: 1%;
    }
  }

  .search-detail-close {
    height: 0;
    opacity: 0;
  }
}

.page {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/approveManage/orderApprove/index.vue